<template>
  <div>
    <generic-container
      :title="$t('course section')"
      icon="book"
      :header_buttons="header_buttons"
    >
      <h2 class="ui header">
        <i class="users icon"></i>
        <div class="content" v-if="section && section.crs_course">
          {{ section.name }} <small>| {{ section.setup.schedule }}</small>
          <div
            class="sub header"
            v-if="
              section &&
              section.crs_assignation_season &&
              section.crs_assignation_season
            "
          >
            {{ section.crs_course.name }} -
            {{ section.crs_assignation_season.name }}
          </div>
        </div>
      </h2>
      <h4 class="ui dividing header">{{ $t("weighting") }}</h4>
      <div
        class="ui four cards"
        v-if="section && section.setup && section.setup.weighting"
      >
        <div
          class="ui card"
          v-for="(w, widx) in section.setup.weighting"
          :key="widx"
        >
          <div class="content">
            <h4 class="ui dividing header">
              <div>
                <i class="fitted small book icon"></i>
                {{ w.name }} <small>{{ w.weighting_percent }}% </small>
              </div>
            </h4>
            <div class="description">
              <div class="ui bulleted list">
                <div class="item" v-for="(t, tidx) in w.tasks" :key="tidx">
                  <div class="content">
                    {{ t.name }} <small>{{ t.weighting_percent }}%</small>
                  </div>
                </div>
              </div>
              <!-- <pre>{{ w.tasks }}</pre> -->
            </div>
          </div>
        </div>
      </div>
      <div
        class="ui cards"
        v-else-if="
          section &&
          section.crs_course &&
          section.crs_course.setup &&
          section.crs_course.setup.weighting
        "
      >
        <div
          class="ui icon warning message"
          style="margin: 20px 20px 10px 20px"
        >
          <i class="exclamation triangle icon"></i>
          <div class="content">
            <div class="header">
              {{ $t("not configured yet") }}
            </div>
            <p>
              {{
                $t(
                  "below configuration is from course default, edit according your consideration",
                )
              }}
            </p>
          </div>
        </div>
        <div
          class="ui blue card"
          v-for="(w, widx) in section.crs_course.setup.weighting"
          :key="widx"
        >
          <div class="content">
            <a class="ui dividing header"
              >{{ w.name }} [{{ w.weighting_percent }}%]</a
            >
            <div class="description">
              <div class="ui relaxed list">
                <div class="item" v-for="(t, tidx) in w.tasks" :key="tidx">
                  <div class="content">
                    {{ t.name }} [{{ t.weighting_percent }}%]
                  </div>
                </div>
              </div>
              <!-- <pre>{{ w.tasks }}</pre> -->
            </div>
          </div>
        </div>
      </div>

      <h2 class="ui dividing header">
        <i class="users icon"></i> {{ $t("students") }}
      </h2>
      <div class="ui info message" style="display: block">
        <div class="header">{{ $t("important") }}</div>
        <p
          v-html="
            $t(
              'scores below must be meassured in a scale where the maximum is',
            ) +
            ' ' +
            '<strong>' +
            measurement_limit +
            '</strong>'
          "
        ></p>
        <p
          v-html="
            $t(
              'checkbox on every score input should be marked when the student is absent',
            )
          "
        ></p>
      </div>
      <div class="ui form">
        <table
          class="ui celled structured table"
          v-if="section && section.setup && section.setup.weighting"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th rowspan="2">{{ $t("name") }}</th>
              <th
                :colspan="w.tasks.length"
                v-for="(w, widx) in section.setup.weighting"
                :key="widx"
              >
                <i
                  class="stamp icon"
                  v-bind:class="{ green: is_stage_locked(w) }"
                  v-if="is_stage_locked(w)"
                ></i
                >{{ w.name }} <small>{{ w.weighting_percent }}%</small>
              </th>
              <th rowspan="2">{{ $t("final") }}</th>
              <!-- <th :colspan="section.setup.weighting.length + 1">
                {{ $t("total score") }}
              </th> -->
            </tr>
            <tr>
              <th v-for="(w, widx) in wcols" :key="widx">
                {{ w.name }}
                <small v-if="w.weighting_percent"
                  >{{ w.weighting_percent }}%</small
                >
              </th>
              <!-- <th v-for="(w, widx) in wtotals" :key="'k' + widx">
                {{ w.name }}
              </th> -->
            </tr>
          </thead>
          <tbody>
            <!-- <tr
              v-for="(student, sidx) in section.crs_assignation_students"
              :key="sidx"
            >
              <td>{{ student.std_student.name }}</td>
              <td v-for="(w, widx) in wcols" :key="widx">
                <input type="text" name="" id="" />
              </td>
              <td></td>
            </tr> -->
            <tr v-for="(score, sidx) in scores" :key="sidx">
              <td>{{ score.student.name }}</td>
              <td v-for="(w, widx) in wcols" :key="widx">
                <!-- <div class="ui right labeled input"> -->
                <!-- <div class="ui action input"> -->
                <input
                  type="text"
                  v-model="scores[sidx].weighting[widx].score"
                  :data-phid="w.phase_uuid"
                  ref="score_inputs"
                />
                <!-- <div class="">
                    <div
                      class="ui checkbox"
                      :data-phid="w.phase_uuid"
                      ref="score_absent_checkbox"
                    >
                      <input type="checkbox" />
                      <label></label>
                    </div>
                  </div> -->
                <!-- </div> -->

                <!-- <div class="ui basic label">/ {{ measurement_limit }}</div> -->
                <!-- </div> -->
              </td>
              <td>{{ calculate_total(score) }}</td>
              <!-- <td v-for="(w, widx) in wtotals" :key="'k' + widx">
                {{ w.score }}
              </td> -->
              <!-- <td></td> -->
            </tr>
          </tbody>
        </table>
        <table class="ui celled structured table" v-else>
          <thead>
            <tr>
              <th rowspan="2">{{ $t("student") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(student, sidx) in section.crs_assignation_students"
              :key="sidx"
            >
              <td>{{ student.std_student.name }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <pre>{{ section }}</pre> -->
      <!-- <div class="ui list">
        <div
          class="item"
          v-for="(grl, grlidx) in assignation.setup.general"
          :key="grlidx"
        >
          {{ grl.name }}: {{ grl.value }}
        </div>
      </div>
      <div
        v-show="
          assignation.setup &&
            assignation.setup.courses &&
            assignation.setup.courses.length
        "
      >
        <div class="ui top attached tabular menu" ref="tabs">
          <a
            class="item"
            v-for="(course, crsidx) in assignation.setup.courses"
            :key="crsidx"
            :data-tab="'_' + course.uuid"
            >{{ course.name }}</a
          >
        </div>
        <div
          class="ui bottom blue attached tab segment"
          v-for="(course, crsidx) in assignation.setup.courses"
          :key="crsidx"
          :data-tab="'_' + course.uuid"
        >
          <course :course="course" :season="assignation" />
        </div>
      </div> -->
    </generic-container>
  </div>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import { local_api, error_toast, success_toast } from "@/utils";
import { cloneDeep } from "lodash";
// import Course from "./Course";

// @ is an alias to /src
export default {
  name: "CourseScoringRevisionIndex",
  components: {
    "generic-container": GenericContainer,
    // Course,
  },
  filters: filters,
  data() {
    return {
      section: {},
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.init,
        },
        {
          icon: "orange edit",
          tooltip: this.$t("edit"),
          click: this.edit,
        },
        {
          icon: "blue save",
          tooltip: this.$t("save"),
          click: this.save,
        },
      ],
      scores: {},
      records: [],
      measurement_limit: "",
    };
  },
  computed: {
    wcols() {
      let vm = this;
      if (vm.section && vm.section.setup && vm.section.setup.weighting) {
        let r = [];
        for (let i = 0; i < vm.section.setup.weighting.length; i++) {
          const wei = vm.section.setup.weighting[i];
          for (let j = 0; j < wei.tasks.length; j++) {
            const task = wei.tasks[j];
            // console.log(task);
            r.push({
              stage: wei.name,
              name: task.name,
              weighting_percent: task.weighting_percent,
              phase_uuid: wei.uuid,
            });
          }
          /**
           * Add for stage total
           */
          // r.push({
          //   name: vm.$t("total"),
          // });
        }
        return r;
      } else return [];
    },
    wtotals() {
      let vm = this;
      if (vm.section && vm.section.setup && vm.section.setup.weighting) {
        let r = [];
        for (let i = 0; i < vm.section.setup.weighting.length; i++) {
          const wei = vm.section.setup.weighting[i];
          let score = 0;
          // for (let j = 0; j < wei.tasks.length; j++) {
          //   const task = wei.tasks[j];
          //   // console.log(task);

          // }
          r.push({
            name: wei.name,
            score: score,
          });
          /**
           * Add for stage total
           */
          // r.push({
          //   name: vm.$t("total"),
          // });
        }
        r.push({
          name: vm.$t("total"),
          score: 0,
        });

        return r;
      } else return [];
    },
  },
  methods: {
    init() {
      let vm = this;
      let section_uuid = this.$route.query.i;
      if (section_uuid) {
        local_api(vm, "post", "/course/section/do-get", {
          u: section_uuid,
        })
          .then((section) => {
            vm.section = section;

            /**
             * Get stored scores
             */
            local_api(vm, "post", "/course/scoring/do-get", {
              u: section_uuid,
            })
              .then((currentScores) => {
                /**
                 * Calculate scores
                 */

                if (section.crs_assignation_students) {
                  vm.scores = section.crs_assignation_students.map((s) => {
                    // let weighting = [];
                    // if (section.setup && section.setup.weighting) {
                    //   weighting = section.setup.weighting;
                    // }

                    let we = cloneDeep(vm.wcols);

                    let trgt = currentScores.find((sc) => {
                      return sc.student_id == s.std_student.student_id;
                    });

                    if (trgt) {
                      we = we.map((w) => {
                        let tgt = trgt.setup.find((t) => {
                          return t.stage == w.stage && t.name == w.name;
                        });

                        if (tgt) w.score = tgt.score;

                        return w;
                      });

                      return {
                        student: s.std_student,
                        weighting: we, //JSON.parse(trgt.setup),
                      };
                    } else {
                      return {
                        student: s.std_student,
                        weighting: we,
                      };
                    }
                  });
                }
              })
              .catch((err) => {
                error_toast(err);
              });
          })
          .catch((err) => {
            error_toast(err);
          });
      } else {
        error_toast(this.$t("no course section found"));
      }

      /** Get module configuration */
      local_api(vm, "post", "/course/scoring/do-get-configuration")
        .then((moduleConfiguration) => {
          if (moduleConfiguration) {
            if (moduleConfiguration.measurement_limit)
              vm.measurement_limit = moduleConfiguration.measurement_limit;
            if (moduleConfiguration.lock_stage_when_record_generated) {
              vm.lock_stages_due_record();
            }
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    edit() {
      let section_uuid = this.$route.query.i;
      this.$router.push({
        name: "CourseScoringEdit",
        query: { i: section_uuid },
      });
    },
    save() {
      let vm = this;
      let section_uuid = this.$route.query.i;

      local_api(vm, "post", "/course/scoring/do-save", {
        s: vm.scores,
        u: section_uuid,
      })
        .then(() => {
          success_toast(vm.$t("scoring saved"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    lock_stages_due_record() {
      let vm = this;

      if (!vm.records.length) {
        vm.request_records()
          .then(() => {
            vm.do_lock_stages();
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        vm.do_lock_stages();
      }
    },
    do_lock_stages() {
      let vm = this;
      let inputs = vm.$refs.score_inputs;
      inputs.map((inpt) => {
        let trgt = vm.records.find((rcd) => {
          return rcd.phase_uuid == jQuery(inpt).data("phid");
        });
        if (trgt) window.jQuery(inpt).attr("disabled", "disabled");
      });
    },
    request_records() {
      let vm = this;
      return new Promise((resolve, reject) => {
        let section_uuid = vm.$route.query.i;

        local_api(vm, "post", "/course/scoring/do-get-section-records", {
          u: section_uuid,
        })
          .then((records) => {
            vm.records = records;
            resolve();
          })
          .catch((err) => {
            error_toast(err);
            reject(err);
          });
      });
    },
    is_stage_locked(stage) {
      let vm = this;
      if (vm.records) {
        let trgt = vm.records.find((rc) => {
          return rc.phase_uuid == stage.uuid;
        });
        if (trgt) return true;
        else return false;
      } else {
        return false;
      }
    },
    calculate_total(score) {
      let vm = this;

      if (vm.section && vm.section.setup && vm.section.setup.weighting) {
        let stages = vm.section.setup.weighting.map((w) => {
          w.total = score.weighting.reduce((prev, curr) => {
            if (curr.phase_uuid == w.uuid) {
              return (
                prev +
                (isNaN(curr.score)
                  ? 0
                  : Number(curr.score) * Number(curr.weighting_percent)) /
                  100
              );
            } else return prev;
          }, 0);
          return w;
        });
        let sum = stages.reduce((prev, curr) => {
          return (
            prev + (Number(curr.total) * Number(curr.weighting_percent)) / 100
          );
        }, 0);
        return sum;
      } else {
        return "?";
      }
    },
  },
  created() {},
  mounted() {
    let vm = this;
    vm.init();
  },
  watch: {},
};
</script>
